module.exports = __webpack_public_path__ + "img/images.85266b16.png";